// extracted by mini-css-extract-plugin
module.exports = {"wrap":"player_wrap__8MKV1","title":"player_title__4qdUF","text":"player_text__vubXM"};